// extracted by mini-css-extract-plugin
export default {"Box":"base-cell-module__Box--ZP0qi","editingCell":"base-cell-module__editingCell--e2wnV","disallowSelection":"base-cell-module__disallowSelection--lXodR"};